/*  This script dynamically manages the email and password fields on a user account form 
    based on the user's authentication methods, as indicated in a JWT token cookie. It determines which fields to 
    disable or hide according to the following rules:
  
        - "Username-Password-Auth-SDBS-API" only: Both email and password fields are enabled.
        - "google-oauth2" only: Both email and password fields are disabled and hidden.
        - Both "Username-Password-Auth-SDBS-API" and "google-oauth2": Email is disabled, password is visible and enabled.
        - No connections: Both email and password fields are enabled.
 */
(function() {
    // Authentication connection types
    const GOOGLE_AUTH = "google-oauth2";
    const SDBS_AUTH = "Username-Password-Auth-SDBS-API";

    const ACCESS_TOKEN_COOKIE = 'access-token';
    const ACCESS_TOKEN_CONNECTIONS_PROP = 'https://native-instruments.com/connections';

    const SELECTORS = {
        usernameField: 'input[name="tx_niaccount_niaccount[updateUser][username]"]',
        updatePasswordSection: '#updatePasswordSection',
        usernameMessage: '#usernameMessage',
    };

    function getCookie(name) {
        const cookies = document.cookie.split(";").map(cookie => cookie.trim());
        const cookie = cookies.find(cookie => cookie.startsWith(name + "="));
        return cookie ? decodeURIComponent(cookie.split("=")[1]) : null;
    }

    function decodeToken(token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }

    // determine which fields should be disabled based on the connections
    function determineFieldDisabling(connections) {    
        // Default: both email and password are enabled
        let disableUsername = false;
        let disablePassword = false;
    
        // If connections array doesn't exist or is empty, keep both enabled
        if (!connections || connections.length === 0) {
            return { disableUsername, disablePassword };
        }
    
        // Check if the connection types exist in the list
        const hasGoogleAuth = connections.includes(GOOGLE_AUTH);
        const hasSDBSAuth = connections.includes(SDBS_AUTH);
    
        // Logic for determining field disabling
        if (hasSDBSAuth && hasGoogleAuth) {
            // Both SDBS and Google Auth present: Disable username (email), enable password
            disableUsername = true;
            disablePassword = false;
        } else if (hasGoogleAuth) {
            // Only Google Auth present: Disable both username (email) and password
            disableUsername = true;
            disablePassword = true;
        } else if (hasSDBSAuth) {
            // Only SDBS Auth present: Enable both username (email) and password
            disableUsername = false;
            disablePassword = false;
        }
    
        return { disableUsername, disablePassword };
    }

    function applyFieldDisabling({ disableUsername, disablePassword }) {
        const usernameField = document.querySelector(SELECTORS.usernameField);
        const updatePasswordSection = document.querySelector(SELECTORS.updatePasswordSection);
    
        // Handle the username (email) field disabling/enabling
        if (usernameField) {
            if (disableUsername) {
                usernameField.disabled = true;
                // Show the message that the username is disabled
                document.querySelector(SELECTORS.usernameMessage).style.display = 'block';
            } else {
                usernameField.disabled = false;
                document.querySelector(SELECTORS.usernameMessage).style.display = 'none';
            }
        }
    
        // Handle the password section hiding/showing
        if (updatePasswordSection) {
            if (disablePassword) {
                updatePasswordSection.style.display = 'none';
            } else {
                updatePasswordSection.style.display = 'block';
            }
        }
    }

    function disableFieldsBasedOnConnections() {
        const token = getCookie(ACCESS_TOKEN_COOKIE);
        if (token) {
            const payload = decodeToken(token);
            const connections = payload[ACCESS_TOKEN_CONNECTIONS_PROP];

            // Apply field disabling based on connections
            const disablingConfig = determineFieldDisabling(connections);
            applyFieldDisabling(disablingConfig);
        } else {
       
            applyFieldDisabling({ disableUsername: false, disablePassword: false });
        }
    }
    document.addEventListener('DOMContentLoaded', disableFieldsBasedOnConnections);
})();